const ENBCGItems = {
	"Alterar item BCG": "Change BCG item",
	"Criar novo Item BCG": "Create new BCG item",
	"Deseja realmente excluir o item BCG": "Do you really want to delete the BCG item",
	"Erro ao adicionar item BCG": "Error adding BCG item",
	"Erro ao alterar item BCG": "Error changing BCG item",
	"Erro ao excluir item BCG": "Error deleting BCG item",
	"Exclusão do Item BCG": "Delete Item BCG",
	"Itens BCG": "Items BCG",
	"Inserir item BCG": "Insert BCG item",
	"Item BCG adicionado com sucesso": "BCG item successfully added",
	"Item BCG alterado com sucesso": "BCG item changed successfully",
	"Item BCG excluído com sucesso": "BCG item deleted successfully",
	"Novo Item BCG": "New BCG Item",
	"Todos": "All",
	"Todas": "All"
};

export default ENBCGItems;

